/* eslint-disable max-len */
import React from 'react';

function EligibilityVerificationIcon({
  width = 24,
  height = 24,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      {...rest}>
      <path
        d="M12 1.2L2.8 5.1v5.9c0 5.3 4.1 10.3 9.2 11.5 5.1-1.2 9.2-6.2 9.2-11.5V5.1L12 1.2zm0 1.3l7.5 3.1v5.4c0 4.5-3.2 8.7-7.5 10-4.3-1.3-7.5-5.5-7.5-10V5.6L12 2.5z"
        fill="currentColor"
      />
      <path
        d="M9.8 12.7l-2.5-2.5-1.2 1.2 3.7 3.7 7-7-1.2-1.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default EligibilityVerificationIcon;
